export default {
  root: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
  },
  inputContainer: {
    display: 'flex',
    justifyContent: 'center',
  },
  actions: {
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
  },
};
